import React, { useState } from 'react';
import styled from 'styled-components';
import Logo from '../components/Logo/Logo';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import Footer from '../components/Footer/Footer';
import API from '../api';
import { authData } from '../utils';

const StyledMain = styled.main`
  width: 95%;
  max-width: 1800px;
  height: auto;
  margin: 0 auto;
  padding: 0px;
`;

// const StyledAuthHeader = styled.section`
//   width: 100%;
//   height: auto;
//   margin-bottom: 30px;
//   @media (max-width: 1000px) {
//     margin-bottom: 10px;
//   }
// `;

// const StyledAuthFormSection = styled.section`
//   width: 450px;
//   height: auto;
//   margin: 0px auto;
//   padding: 0px;
//   @media (max-width: 1000px) {
//     width: 100%;
//   }
// `;

const StyledAuthMainOuter = styled.section`
  width: calc(100% - 100px);
  height: calc(100% - 100px);
  background-color: #d3f0ff;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  padding: 50px;
  @media (max-width: 1000px) {
    width: 100%;
    padding: 0px;
    height: 100%;
  }
`;

const StyledMainSection = styled.section`
  background-color: rgb(255, 255, 255);
  width: 100%;
  max-width: 1200px;
  height: auto;
  margin: 0px;
  display: flex;
  flex-direction: row-reverse;
  column-gap: 30px;
  padding: 30px;
  border-radius: 30px;
  @media (max-width: 1000px) {
    width: 100%;
    display: flex;
    padding: 10px;
    height: 100% !important;
    border-radius: 0;
    justify-content: center;
    align-items: flex-start;
  }
`;

const StyledAuthHeader = styled.section`
  width: 100%;
  height: auto;
  text-align: center;
  display: none;
  @media (max-width: 1000px) {
    display: flex;
  }
`;

const StyledAuthFormSection = styled.section`
  width: 50%;
  height: auto;
  margin: 0px;
  padding: 0px;
  overflow-y: scroll;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-width: 1000px) {
    width: 100%;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;

const StyledAuthFormIn = styled.section`
  width: 410px;
  @media (max-width: 1000px) {
    width: 95%;
    max-width: 410px;
  }
`;

const StyledContentArea = styled.section`
  width: 60%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 30px;
  }
  @media (max-width: 1000px) {
    display: none;
  }
`;

const withAuthHOC = (WrappedComponent) => {
  return (props) => {
    const { appName, appLogo } = props.appData;

    return (
      <>
        <StyledAuthMainOuter>
          <StyledMainSection>
            <StyledAuthFormSection>
              <StyledAuthHeader>
                <Logo src={appLogo} type="auth" alt={appName} />
              </StyledAuthHeader>
              <StyledAuthFormIn>
                <WrappedComponent {...props} />
              </StyledAuthFormIn>
            </StyledAuthFormSection>
            <StyledContentArea>
              <img src={appLogo} alt={appName} />
            </StyledContentArea>
          </StyledMainSection>
        </StyledAuthMainOuter>

        {/* <StyledAuthFormSection>
          <StyledAuthHeader>
            <Logo src={appLogo} alt={appName} type="auth" />
          </StyledAuthHeader>
          <WrappedComponent {...props} />
        </StyledAuthFormSection> */}
      </>
    );
  };
};

const withAppHOC = (WrappedComponent) => {
  return (props) => {
    const { appName, appLogo } = props.appData;
    const [showNav, setShowNav] = useState(false);

    const onClickLogout = (e) => {
      e.preventDefault();
      const { authToken } = authData.get();
      API.delete(`/authentication/sessions/?sessionToken=${authToken}`);
      authData.clear();
      window.location.href = '/login';
    };

    const onClickNavigationIcon = () => {
      setShowNav((showNav) => !showNav);
    };

    return (
      <>
        <Header
          onClickLogout={onClickLogout}
          appLogo={appLogo}
          appName={appName}
          showNav={showNav}
          setShowNav={onClickNavigationIcon}
        />
        <Navigation showNav={showNav} {...props} />
        <StyledMain>
          <WrappedComponent {...props} />
        </StyledMain>
        <Footer appName={appName} />
      </>
    );
  };
};

export { withAuthHOC, withAppHOC };
